module.exports = __webpack_public_path__ + "static/media/swimming.27056518.svg";